// src/status.ts
var LICENCE_LABELS = {
  onboarding: "Onboarding",
  active: "Active",
  paused: "Paused",
  archived: "Archived"
};
var LICENCE_TONES = {
  onboarding: "neutral",
  active: "info",
  paused: "warning",
  archived: "neutral"
};
function licenceStatus(universe) {
  return universe.status ?? "onboarding";
}
function universeStatusChip(universe) {
  if (universe.active_uds_version) {
    return { label: `Released \xB7 v${universe.active_uds_version}`, tone: "success" };
  }
  const status = licenceStatus(universe);
  return { label: LICENCE_LABELS[status], tone: LICENCE_TONES[status] };
}

export { licenceStatus, universeStatusChip };
//# sourceMappingURL=chunk-RFIS2HKK.js.map
//# sourceMappingURL=chunk-RFIS2HKK.js.map